import { showLoadingScreen } from "./loading-screen";

$(document).on('turbolinks:load', function() {
  if ($('.item-setting-form').length === 0) return;

  $(document).off('submit.itemSettings ajax:success.itemSettings ajax:error.itemSettings');
  $(document).on('submit.itemSettings', '.item-setting-form', function() {
    showLoadingScreen();
  });
  $(document).on('ajax:success.itemSettings', '.item-setting-form', function(e, data, status, xhr) {
    let responseData = e.originalEvent.detail[0];
    let itemSettingId = responseData.item_setting_id;

    $("#item-setting-" + itemSettingId).removeClass("table-danger");
    showAlert(responseData.msg, t('success', 'javascript.item_settings'));
  }).on('ajax:error.itemSettings', '.item-setting-form', function(e, xhr, status, error) {
    let responseData = e.originalEvent.detail[0];
    showAlert(responseData.msg);
  });
});